import { render, staticRenderFns } from "./RadioDropdown.vue?vue&type=template&id=52d6ccb2&scoped=true&"
import script from "./RadioDropdown.vue?vue&type=script&lang=js&"
export * from "./RadioDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6ccb2",
  null
  
)

export default component.exports